export const LOAD_INSIGHT_VERBATIM_SUCCESS =
  'INSIGHT_LOAD_INSIGHT_VERBATIM_SUCCESS';

export const loadInsightVerbatimSuccess = verbatim => ({
  type: LOAD_INSIGHT_VERBATIM_SUCCESS,
  verbatim,
});
